import styled from 'styled-components';

import ButtonLink from '../../interface/ButtonLink';

export const ContentWrapper = styled.div`
  color: var(--color-text-light);
  @media (${({ theme }) => theme.respondTo.tablet}) {
    padding-top: 6.5rem;
  }
`;

export const CtaButton = styled(ButtonLink)`
  margin-top: 4rem;

  @media (${({ theme }) => theme.respondTo.mobile}) {
    width: 100%;
    text-align: center;
  }
`;

export const ImageWrapper = styled.div`
  > * {
    border-radius: 8rem 8rem 8rem 0;
  }

  @media (${({ theme }) => theme.respondTo.mobile}) {
    margin-top: 4.5rem;
  }

  @media (${({ theme }) => theme.respondTo.tablet}) {
    max-width: 50%;
    flex: 0 0 52rem;
    align-self: flex-end;
    margin-left: 3rem;

    > * {
      border-radius: 16rem 16rem 16rem 0;
    }
  }

  @media (${({ theme }) => theme.respondTo.desktop}) {
    margin-left: 6rem;
  }

  @media (${({ theme }) => theme.respondTo.desktopL}) {
    margin-left: 17rem;
  }
`;

export const Split = styled.div`
  display: flex;

  @media (${({ theme }) => theme.respondTo.mobile}) {
    flex-direction: column;
  }

  @media (${({ theme }) => theme.respondTo.tablet}) {
    justify-content: space-between;
  }
`;

export const Text = styled.div`
  margin-top: 2rem;

  @media (${({ theme }) => theme.respondTo.tablet}) {
    margin-top: 4rem;
  }
`;

export const Title = styled.h1`
  font-size: 5.2rem;

  @media (${({ theme }) => theme.respondTo.tablet}) {
    font-size: 6.4rem;
  }
`;

export const Wrapper = styled.div`
  padding-top: 17rem;
  margin-bottom: 8rem;

  @media (${({ theme }) => theme.respondTo.tablet}) {
    padding-top: 21.5rem;
  }

  @media (${({ theme }) => theme.respondTo.desktop}) {
    margin-bottom: 14.5rem;
  }
`;
